import React, { type ComponentPropsWithoutRef } from 'react';

import HoverableElement from '../HoverableElement';
import { InteractableIconPositioner } from './Styles';

interface IconWrapperProps extends ComponentPropsWithoutRef<typeof InteractableIconPositioner> {
  tooltipText?: string;
  clickable: boolean;
  children: React.ReactElement;
  isTriggerElementClickable: boolean;
}

/**
 * Positions and styles the input icon to align it correctly and to ensure
 * that it is clickable and hoverable if necessary, without making it interactible
 * if it's supposed to make clicks fall through to the underlying input.
 */
export const IconWrapper: React.FC<IconWrapperProps> = ({
  children,
  clickable,
  tooltipText,
  isTriggerElementClickable,
  ...props
}) => {
  const isInteractible = clickable || tooltipText !== undefined;

  if (!isInteractible) {
    return children;
  }

  return (
    <InteractableIconPositioner {...props}>
      {tooltipText !== undefined ? (
        <HoverableElement
          isTriggerElementClickable={isTriggerElementClickable}
          tooltipText={tooltipText}
        >
          {children}
        </HoverableElement>
      ) : (
        children
      )}
    </InteractableIconPositioner>
  );
};
